import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserState {
  user: {
    id: string | number;
    email: string;
    fullName?: string;
    username?: string;
    profPics?: string;
    userType?: string | null;
    genres?: string[];
    profileIncomplete?: boolean;
    [key: string]: any;
  } | null;
  isAuthenticated: boolean;
  setUser: (user: any) => void;
  logout: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      setUser: (payload) => {
        // Handle nested user object if present (consistent with the JSON provided by the user)
        const rawUser = payload?.user ? payload.user : payload;
        if (!rawUser) {
          set({ user: null, isAuthenticated: false });
          return;
        }

        // Map to standard camelCase
        const userData = {
          ...rawUser,
          id: String(rawUser.id ?? ''),
          fullName: rawUser.full_name ?? rawUser.fullName,
          profPics: rawUser.prof_pics ?? rawUser.profPics,
          userType: rawUser.user_type ?? rawUser.userType,
          profileIncomplete: !!(rawUser.profile_incomplete ?? rawUser.profileIncomplete),
          genres: rawUser.genres ?? [],
        };

        set({ user: userData, isAuthenticated: true });
      },
      logout: () => set({ user: null, isAuthenticated: false }),
    }),
    {
      name: 'user-storage',
    },
  ),
);
